<div class="container-fluid">
    <div class="row">
        
            <div class="banner-wrap">
                <div class="col-md-12">
           
        <div class="login-main">
            <div class="login-bg">
                <img src="../../../../assets/images/bonds-logo1.svg" alt="logo">
            </div>
            </div>
            <div class="col-md-5 offset-md-3">
            <div class="login-form-main">
                <span> <img src="../../../../assets/images/web_login_user.svg"></span>
                    <h3 class="text-center form-title">{{heading_message}}</h3>
                    <p class="text-center form-des">{{paragraph_message}}</p>

                    <ng-container *ngIf="!has_cancelled">
                    <div class="d-flex align-items-center justify-content-center mt-4 btn-wrap">
                      <button type="submit" class="btn common-btn ghost-btn" (click)="cancelHandler()">Cancel</button>
                      <button type="submit" class="btn common-btn" (click)="logoutHandler()">Proceed</button>
                    </div>
                    
                    </ng-container>
                    <ng-container *ngIf="has_cancelled">
                        <button type="submit" class="btn btn-warning rounded-pill px-5" (click)="okayHandler()">Ok</button>
                    </ng-container>
            </div>
        </div>
    </div>
</div>
    </div>
</div>


